import { render, staticRenderFns } from "./UserGridAlert.vue?vue&type=template&id=4a490228&scoped=true&"
import script from "./UserGridAlert.vue?vue&type=script&lang=ts&"
export * from "./UserGridAlert.vue?vue&type=script&lang=ts&"
import style0 from "./UserGridAlert.vue?vue&type=style&index=0&id=4a490228&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a490228",
  null
  
)

export default component.exports